var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLogic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 76,
    viewBox: "0 0 83 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 -16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 51,
    r: 35,
    fill: "#FFDCE3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F7465F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M30.32 48.617L27.34 43.5l-8.986-15.475-1.724 7.785 1.724-7.785L18.34 28l.014.025.006-.025-.006.025L30.32 48.617a11.992 11.992 0 0 1 12.05.004l11.956-20.596-7.695 1.695 7.695-1.695L42.37 48.621A12.002 12.002 0 0 1 48.34 59l-6 10.39a12 12 0 0 1-12.02-20.773zM54.45 89.985l.069.015-.069-.015.009.015-.009-.015-7.741-1.705 7.741 1.705L42.84 70l-.37-.64 11.981 20.625zm-35.976-.01L30.34 69.53 18.475 89.975l7.695-1.695-7.695 1.695zm0 0L18.46 90l.015-.025-.115.025.115-.025zm35.85-61.95L54.34 28l-.015.025.115-.025-.115.025zM65.34 53.34L71 59l-5.66-5.66zm0 11.32L71 59l-5.66 5.66zM4 59h12H4zm65 0H48.34 69zM56.17 35.81L54.44 28l1.73 7.81zm-30-6.09L18.36 28l7.81 1.72zm-9.54 52.47L18.36 90l-1.73-7.81zm39.62 0L54.52 90l1.73-7.81zM6 64.66L.34 59 6 64.66zm0-11.32L.34 59 6 53.34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogic);
export default __webpack_public_path__ + "static/media/ic-logic.76398a393af34edd1f4219cc9affd589.svg";
export { ForwardRef as ReactComponent };